/**************************************************************************************************************************************************
*   MODULE NAME     :  Header
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  11-01-2021
*   DESCRIPTION     :  Component to Application Header
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React, { Component } from "react";
import { Row, Col, Container, Button, Dropdown } from 'react-bootstrap';
import { NavLink, matchPath } from 'react-router-dom';
import { FaHome, FaListAlt, FaSearch, FaMedium, FaFileUpload, FaUserCog, FaRegPlusSquare, FaCartPlus, FaUserPlus, FaFolderPlus, FaColumns } from 'react-icons/fa';
import { MdAddToQueue, MdDashboard, MdHelp } from "react-icons/md";
import { } from 'react-icons/'
import './Header.css'
import lillyLogo from '../../assets/LillyLogo_Red.png';
import logo from '../../assets/logo.PNG';
import { ddmmmyyyyFormat } from "../common/DateFormat";


class Header extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <header className="header" username={this.props.userDetails.firstName + " " + this.props.userDetails.lastName}>
        <div className="primaryHeader">
          <Container fluid>
            <Row>
              <Col sm={6} className="pl-0">
                <a href="https://now.lilly.com/" className="lillyLogoWrap" target="_blank" rel="noopener noreferrer">
                  <img src={lillyLogo} className="lillyLogo" alt="lillyLogo" />
                </a>
                <span className="divider" />
                <a href="/" className="logoApp">
                  <img src={logo} className="logoImg" alt="lillyLogo" />
                </a>
              </Col>

              <Col sm={6} className="text-right welcometext ">
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="userDetailsDropdown" id="userDetailsDropdown">
                    Welcome {this.props.userDetails.firstName} {this.props.userDetails.lastName}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="div">System ID: {this.props.userDetails.userClientId}</Dropdown.Item>
                    {this.props.userDetails && <Dropdown.Item as="div">Role: {`${this.props.userDetails.siteOfOrigin === "None" ? '' : this.props.userDetails.siteOfOrigin } ${this.props.userDetails.role.substr(5).split("_").join(" ")}`}</Dropdown.Item>}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </Container>
        </div>

        {!matchPath(window.location.pathname, { path: '/searchResult/:searchId/:title' }) &&
          !matchPath(window.location.pathname, { path: '/searchResult/:searchId' }) &&
          !matchPath(window.location.pathname, { path: '/abstractDetail/:abstractId' }) &&
          !matchPath(window.location.pathname, { path: '/audit/:abstractId' }) &&
          !matchPath(window.location.pathname, { path: '/dashboardresults/:site/:datatype' }) &&
          !matchPath(window.location.pathname, { path: '/metricresults' }) &&
          <div className="menuHeader">
            <Container fluid>
              <Row>
                <Col sm={12} className="mainMenu pl-0 pr-0">
                  <ul>
                    {this.props.userDetails.role !== "GLSD_Viewer" && this.props.userDetails.role !== "GLSD_IT_Administrator" && (
                      <li><NavLink to='/createNewAbstract'><FaRegPlusSquare />Create New Abstract</NavLink> </li>
                    )}
                    <li><NavLink to='/abstracts'><FaListAlt />abstracts</NavLink> </li>
                    <li><NavLink to='/search'><FaSearch />search</NavLink> </li>
                    {this.props.userDetails.role !== "GLSD_Viewer" && this.props.userDetails.role !== "GLSD_IT_Administrator" && (
                      <li><NavLink to='/upload'><FaFileUpload />Upload</NavLink> </li>
                    )}
                    <li><NavLink to='/dashboard'><FaColumns />Dashboard</NavLink> </li>
                    {this.props.userDetails.role !== "GLSD_IT_Administrator" && (
                      <li><NavLink to='/metrics'><FaMedium />metrics</NavLink> </li>
                    )}
                    {
                      (this.props.userDetails.role === 'GLSD_Business_Administrator') &&
                      <li><NavLink to='/administration'><FaUserCog />Administration</NavLink></li>
                    }
                     <li><NavLink to="/help"><MdHelp />Help</NavLink></li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </div>
        }
      </header>
    );
  }
}
export default Header;
